import React, { useEffect } from 'react';

const InternetStatusBanner = () => {
  const [isOnline, setIsOnline] = React.useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  return (
    <>
      {!isOnline && <div
        style={{
          backgroundColor: "red",
          // fontFamily: "cursive",
          color: "white",
          padding: "20px",
          textAlign: "center",
        }}
      >
        🚫 No Internet Connection
      </div>}
    </>
  );
};

export default InternetStatusBanner;
